import { Option } from "../../models/option";

export const tournamentPhases: Option[] = [
  {index: 0, name: 'groups', value: 'GROUPS', playoffs: false},
  {index: 1, name: 'swiss', value: 'SWISS', playoffs: false},
  {index: 2, name: 'round_of_16', value: 'ROUND_OF_16', playoffs: true},
  {index: 3, name: 'quarterfinals', value: 'QUARTER_FINALS', playoffs: true},
  {index: 4, name: 'semifinals', value: 'SEMI_FINALS', playoffs: true},
  {index: 5, name: 'final', value: 'FINAL', playoffs: true},
];